import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import ArchitectureSection from './components/ArchitectureSection';
import AICapabilitiesSection from './components/AICapabilitiesSection';
import APIDocumentationSection from './components/APIDocumentationSection';
import SecuritySection from './components/SecuritySection';
import PerformanceSection from './components/PerformanceSection';
import IntegrationSection from './components/IntegrationSection';
import CTASection from './components/CTASection';

const TechnologyPlatform: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Technology Platform - camlytix AI</title>
        <meta 
          name="description" 
          content="Explore camlytix AI's advanced AI technology platform with cutting-edge algorithms, enterprise security, and comprehensive API documentation for seamless integration." 
        />
        <meta name="keywords" content="AI technology, video analytics platform, computer vision, API documentation, enterprise security, machine learning" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <ArchitectureSection />
          <AICapabilitiesSection />
          <APIDocumentationSection />
          <SecuritySection />
          <PerformanceSection />
          <IntegrationSection />
          <CTASection />
        </main>

        <footer className="bg-authority-charcoal text-primary-foreground py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8 mb-8">
              <div>
                <h3 className="font-bold text-lg mb-4">camlytix AI</h3>
                <p className="text-sm text-primary-foreground/80">
                  Transform vision into intelligence with AI-powered video analytics
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Platform</h4>
                <ul className="space-y-2 text-sm text-primary-foreground/80">
                  <li><a href="/solutions-gallery" className="hover:text-primary-foreground transition-colors">Solutions</a></li>
                  <li><a href="/industry-applications" className="hover:text-primary-foreground transition-colors">Industries</a></li>
                  <li><a href="/technology-platform" className="hover:text-primary-foreground transition-colors">Technology</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Resources</h4>
                <ul className="space-y-2 text-sm text-primary-foreground/80">
                  <li><a href="/implementation-hub" className="hover:text-primary-foreground transition-colors">Documentation</a></li>
                  <li><a href="/partner-ecosystem" className="hover:text-primary-foreground transition-colors">Partners</a></li>
                  <li><a href="#" className="hover:text-primary-foreground transition-colors">Support</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Company</h4>
                <ul className="space-y-2 text-sm text-primary-foreground/80">
                  <li><a href="#" className="hover:text-primary-foreground transition-colors">About Us</a></li>
                  <li><a href="#" className="hover:text-primary-foreground transition-colors">Contact</a></li>
                  <li><a href="#" className="hover:text-primary-foreground transition-colors">Privacy Policy</a></li>
                </ul>
              </div>
            </div>
            
            <div className="pt-8 border-t border-primary-foreground/20 text-center text-sm text-primary-foreground/80">
              <p>&copy; {new Date().getFullYear()} camlytix AI. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default TechnologyPlatform;